import React from 'react';
import ReactMarkdown from 'react-markdown';
import './MarkdownRenderer.css';

const MarkdownRenderer = ({ content }) => {
  return (
    <div className="markdown-container">
      <ReactMarkdown
        components={{
          // Override list rendering to apply custom styling
          ul: ({ node, ...props }) => (
            <ul className="markdown-list" {...props} />
          ),
          ol: ({ node, ...props }) => (
            <ol className="markdown-list" {...props} />
          ),
          li: ({ node, children, ...props }) => (
            <li className="markdown-list-item" style={{ whiteSpace: 'normal' }} {...props}>
            {children}
            </li>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;